import { Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import './noData.scss';
import lottie from 'lottie-web';

const NoData = ({ message, displayImage = true }) => {
  const [animationData, setAnimationData] = useState(null);
  const animationContainer = useRef(null);

  useEffect(() => {
    import('../../../Assets/images/json/dar_no_data.json').then(
      ({ default: data }) => {
        setAnimationData(data);
      },
    );
  }, []);

  useEffect(() => {
    if (animationData) {
      lottie.loadAnimation({
        container: animationContainer.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData,
      });
    }
  }, [animationData]);

  return (
    <div className="no-mapped-skill-container">
      <div className="no-mapped-skill-contents">
        <div
          ref={animationContainer}
          className={`no-mapped-skill-image ${displayImage ? '' : 'no-image'}`}
        ></div>
        <Typography className="no-mapped-skill-text">{message}</Typography>
      </div>
    </div>
  );
};

NoData.propTypes = {
  message: PropTypes.string.isRequired,
  displayImage: PropTypes.bool,
};

export default NoData;
